import React, { useEffect, useState } from 'react';
import { apiGet } from '../../../API/Api_Url';
import { X, Calendar, DollarSign, Home, Users, Clock, FileCheck } from 'lucide-react';
import { FaEdit, FaEye, FaTrash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import ContractorCreateBidModel from '../../Modal/ContractorCreateBidModel';
import ContractorUpdateBidModel from '../../Modal/ContractorUpdateBidModel';
import ContractorDeleteBidModel from '../../Modal/ContractorDeleteBidModel';

function AdminAssignConstructionRequirement() {
  const navigate = useNavigate();
  const [Requirements, setRequirements] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const GetAllAssignRequirement = async () => {
    try {
      setIsUploading(true);
      const response = await apiGet('api/contractor/GetAllAssignRequirement');
      setRequirements(response.data);
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    GetAllAssignRequirement();
  }, []);

  const getStatusColor = (status) => {
    switch (status) {
      case 'Pending':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'Approved':
        return 'bg-green-100 text-green-800 border-green-200';
      case 'Rejected':
        return 'bg-red-100 text-red-800 border-red-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  const formatMaskedAddress = (ur) => {
    const address = ur?.Location?.Address || "";
    const city = ur?.City || "";
    const state = ur?.State || "";
    const pincode = ur?.Pincode || "";

    let maskedAddress = address;

    if (address.length > 10) {
      const start = address.substring(0, 0);
      const end = address.substring(address.length - 5);
      maskedAddress = `${start}****${end}`;
    }

    return `${maskedAddress}, ${city}, ${state} - ${pincode}`;
  };


  const ImageModal = () => {
    if (!selectedImage) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
        <div className="relative max-w-4xl max-h-full">
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute -top-10 right-0 text-white hover:text-gray-300 transition-colors"
          >
            <X size={32} />
          </button>
          <img
            src={selectedImage}
            alt="Construction site"
            className="max-w-full max-h-screen object-contain rounded-lg"
          />
        </div>
      </div>
    );
  };

  const ImageGallery = ({ images }) => {
    if (!images || images.length === 0) return null;

    return (
      <div className="mb-4">
        {images.length === 1 ? (
          <img
            src={images[0]}
            alt="Project"
            className="h-48 w-full object-cover rounded-lg cursor-pointer hover:opacity-90 transition-opacity"
            onClick={() => setSelectedImage(images[0])}
          />
        ) : (
          <div className="grid grid-cols-2 gap-2">
            {images?.slice(0, 4).map((image, index) => (
              <div key={index} className="relative">
                <img
                  src={image}
                  alt={`Project ${index + 1}`}
                  className={`w-full object-cover rounded-lg cursor-pointer hover:opacity-90 transition-opacity ${index === 0 ? 'h-32' : 'h-20'
                    }`}
                  onClick={() => setSelectedImage(image)}
                />
                {index === 3 && images?.length > 4 && (
                  <div className="absolute inset-0 bg-black bg-opacity-50 rounded-lg flex items-center justify-center text-white font-semibold">
                    +{images?.length - 4} more
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const [Quotation, setQuotation] = useState(null);
  const [QuotationError, setQuotationError] = useState(null);
  const [IsQuotationLoading, setIsQuotationLoading] = useState(false);

  const GetQuotationofAJobPost = async (id) => {
    try {
      setIsQuotationLoading(true);
      setQuotation(null);
      setQuotationError(null);

      const response = await apiGet(`api/contractor/GetMyBidRequirement/${id}`);

      if (response?.statusCode === 200) {
        setQuotation(response?.data);
      } else {
        setQuotationError(response?.message || "No Quotation found");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setQuotationError("Error fetching Quotation");
    } finally {
      setIsQuotationLoading(false);
    }
  };



  const [expandedJob, setExpandedJob] = useState(null);

  const toggleQuotations = async (reqId) => {
    if (expandedJob === reqId) {
      setExpandedJob(null);
      setQuotation(null);
      setQuotationError(null);
    } else {
      await GetQuotationofAJobPost(reqId);
      setExpandedJob(reqId);
    }
  };

  const [SelectedQuotation, setSelectedQuotation] = useState(null);
  const [UpdateQuotationModel, setUpdateQuotationModel] = useState(false);

  const OpenUpdateQuotationModel = (req) => {
    setUpdateQuotationModel(true)
    setSelectedQuotation(req)
  }

  const CloseUpdateQuotationModel = () => {
    setUpdateQuotationModel(false)
    setSelectedQuotation(null)
  }

  const [DeleteQuotationModel, setDeleteQuotationModel] = useState(false);

  const OpendeleteQuotationModel = (req) => {
    setSelectedQuotation(req)
    setDeleteQuotationModel(true)
  }

  const CloseDeleteQuotationModel = () => {
    setDeleteQuotationModel(false)
    setSelectedQuotation(null)
  }


  const [AddQuotationModel, setAddQuotationModel] = useState(false);
  const [SelectedReq, setSelectedReq] = useState(null);

  const OpenAddQuotationModel = (req) => {
    setSelectedReq(req)
    setAddQuotationModel(true)
  }

  const CloseAddQuotationModel = () => {
    setSelectedReq(null)
    setAddQuotationModel(false)
  }



  return (
    <div className="p-6 bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">
          Admin All Assigned Construction Requirements
        </h1>
        {isUploading ? (
          <div className="flex items-center justify-center py-20">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
            <p className="ml-4 text-gray-600">Loading assigned requirements...</p>
          </div>
        ) : Requirements?.length === 0 ? (
          <div className="text-center py-20">
            <Home className="mx-auto h-16 w-16 text-gray-400 mb-4" />
            <p className="text-xl text-gray-500">No assigned requirements found.</p>
          </div>
        ) : (
          <div className="grid gap-6 grid-cols-1">
            {Requirements?.map((req) => (
              <div
                key={req?._id}
                className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 overflow-hidden"
              >
                <ImageGallery images={req?.UserRequirement?.SitePhotosOrPlan} />
                <div className="p-6 space-y-4">
                  <div className="flex justify-between items-center">
                    <h3 className="text-xl font-bold text-gray-900">
                      {req?.UserRequirement?.ProjectType}
                    </h3>
                    <span
                      className={`px-3 py-1 text-xs font-semibold rounded-full border ${getStatusColor(
                        req?.UserRequirement?.Status
                      )}`}
                    >
                      {req?.UserRequirement?.Status}
                    </span>
                  </div>
                  <p className="text-sm bg-gray-100 px-3 py-1 rounded-md text-gray-600 italic">
                    {formatMaskedAddress(req?.UserRequirement)}
                  </p>
                  <div className="grid grid-cols-2 md:grid-cols-2 gap-4 text-sm">
                    <div className="flex items-start gap-2 text-gray-700">
                      <Home className="h-4 w-4 text-blue-500 mt-0.5" />
                      <div>
                        <p className="font-medium">Size</p>
                        <p className="text-gray-600">
                          {req?.UserRequirement?.SizeDimension?.Length} x{" "}
                          {req?.UserRequirement?.SizeDimension?.Breadth} x{" "}
                          {req?.UserRequirement?.NumberOfFloors} (
                          {req?.UserRequirement?.SizeDimension?.Area})
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start gap-2 text-gray-700">
                      <Users className="h-4 w-4 text-green-500 mt-0.5" />
                      <div>
                        <p className="font-medium">Floors</p>
                        <p className="text-gray-600">
                          {req?.UserRequirement?.NumberOfFloors}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start gap-2 text-gray-700">
                      <DollarSign className="h-4 w-4 text-purple-500 mt-0.5" />
                      <div>
                        <p className="font-medium">Budget</p>
                        <p className="text-gray-600">
                          {req?.UserRequirement?.Budget}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start gap-2 text-gray-700">
                      <Clock className="h-4 w-4 text-orange-500 mt-0.5" />
                      <div>
                        <p className="font-medium">Timeline</p>
                        <p className="text-gray-600">
                          {req?.UserRequirement?.TimelineInMonths} months
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="pt-3 border-t border-gray-100">
                    <p className="text-sm text-gray-600">
                      <span className="font-medium">Payment:</span>{" "}
                      {req?.UserRequirement?.PaymentMethod}
                    </p>
                  </div>
                </div>
                <div className="px-6 py-4 bg-gray-50 border-t flex flex-wrap justify-between items-center gap-3">
                  <div className="flex items-center text-sm text-gray-500">
                    <Calendar className="h-4 w-4 mr-1" />
                    <span>Created: {formatDate(req?.createdAt)}</span>
                  </div>

                  {req?.UserRequirement?.NeedLocalAuthorityApproval && (
                    <div className="flex items-center text-sm text-red-600 font-medium">
                      <FileCheck className="h-4 w-4 mr-1" />
                      <span>Authority Approval</span>
                    </div>
                  )}

                  <button
                    onClick={() => toggleQuotations(req?.UserRequirement?._id)}
                    className="text-sm text-blue-600 hover:underline flex items-center gap-2 disabled:opacity-50"
                    disabled={IsQuotationLoading}
                  >
                    {IsQuotationLoading && expandedJob === req?.UserRequirement?._id ? (
                      <>
                        <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                        <span>Loading...</span>
                      </>
                    ) : expandedJob === req?.UserRequirement?._id ? (
                      "Hide My Quotations"
                    ) : (
                      "Show My Quotations"
                    )}
                  </button>
                </div>
                {expandedJob === req?.UserRequirement?._id && (
                  <div className="p-6 border-t space-y-4 bg-gray-50">
                    {IsQuotationLoading ? (
                      <p className="text-gray-500 text-sm">Loading Quotation...</p>
                    ) : Quotation && Quotation?.length > 0 ? (
                      Quotation.map((qtn) => (
                        <div
                          key={qtn?._id}
                          className="bg-white rounded-xl shadow-md p-4 border border-gray-200"
                        >
                          <h4 className="text-lg font-semibold text-gray-800 mb-3">
                            My Quotation / Bid
                          </h4>

                          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm bg-gray-50 p-3 rounded-lg border">
                            <div>
                              <span className="font-medium text-gray-600">Bid Amount:</span>{" "}
                              ₹{qtn?.BidAmount}
                            </div>
                            {qtn?.Note && (
                              <div>
                                <span className="font-medium text-gray-600">Note:</span>{" "}
                                {qtn?.Note}
                              </div>
                            )}
                            <div>
                              <span className="font-medium text-gray-600">Created:</span>{" "}
                              {new Date(qtn?.createdAt).toLocaleString()}
                            </div>
                          </div>

                          <div className="mt-4 flex justify-end gap-3">
                            <button
                              onClick={() => OpenUpdateQuotationModel(qtn)}
                              className="flex items-center gap-1 px-3 py-1.5 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 transition"
                            >
                              <FaEdit className="text-xs" /> Update
                            </button>
                            <button
                              onClick={() => OpendeleteQuotationModel(qtn)}
                              className="flex items-center gap-1 px-3 py-1.5 bg-red-600 text-white text-sm rounded-md hover:bg-red-700 transition"
                            >
                              <FaTrash className="text-xs" /> Delete
                            </button>
                          </div>
                        </div>
                      ))
                    ) : (
                      <button
                        onClick={() => OpenAddQuotationModel(req)}
                        className="px-3 py-1.5 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700"
                      >
                        + Create Quotation / Bid
                      </button>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
      <ContractorCreateBidModel
        SelectedReq={SelectedReq}
        isOpen={AddQuotationModel}
        onClose={CloseAddQuotationModel}
        GetAllAssignRequirement={GetAllAssignRequirement}
        setExpandedJob={setExpandedJob}
      />
      <ContractorUpdateBidModel
        SelectedBid={SelectedQuotation}
        isOpen={UpdateQuotationModel}
        onClose={CloseUpdateQuotationModel}
        GetAllAssignRequirement={GetAllAssignRequirement}
        setExpandedJob={setExpandedJob}
      />
      <ContractorDeleteBidModel
        SelectedBid={SelectedQuotation}
        isOpen={DeleteQuotationModel}
        onClose={CloseDeleteQuotationModel}
        GetAllAssignRequirement={GetAllAssignRequirement}
        setExpandedJob={setExpandedJob}
      />
      <ImageModal />
    </div>

  );
}

export default AdminAssignConstructionRequirement;
